import { createContext, Dispatch, SetStateAction } from 'react'

export const defaultContext = {
  user: undefined as IUserType | undefined,
  setUser: (() => {}) as Dispatch<SetStateAction<IUserType | undefined>>,
  membershipStatus: undefined as MembershipStatus | undefined,
  setMembershipStatus: (() => {}) as React.Dispatch<React.SetStateAction<MembershipStatus | undefined>>,
  revokeMembership: (() => {}) as () => Promise<void>,
  loading: true as boolean,
  error: undefined as string | undefined,
}

const PeopleContext = createContext(defaultContext)

export default PeopleContext
